module.exports = __webpack_public_path__ + "static/img/bg.b736f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.png
// module id = C34Q
// module chunks = 1